import styled from "styled-components";
import { PRIMARY_COLOR } from "../../const";

export const Wrapper = styled.div`

`;
export const KatalkViewBox = styled.div`
`;
export const ButtonsBox = styled.div`
    margin-top: 16px;

    display: flex;
    flex-direction: row;
`;
export const FileNameBox = styled.div`
    flex: 1;
    height: 2.6rem;
    background-color: #B2B2B2;
    color: #FEFEFE;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding-left: 8px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    border-radius: 4px;
    font-size: 0.9rem;
`;
export const CustomButton = styled.button`
    margin-left: 18px;
    background-color: ${PRIMARY_COLOR};
    color: white;
    width: 6.2rem;
    border-radius: 4px;
    border: none;
    outline: none;
    cursor: pointer;

    transition: 0.2s;
    &:hover {
        background-color: white;
        border: 1px solid ${PRIMARY_COLOR};
        color: black;
    }
`;
export const ContentsBox  = styled.div`
    font-size: 0.825rem;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    & .loading {
        color: var(--text-color);
    }
`;
export const DataTableBox = styled.table`
    /* border: 1px solid black; */
    margin-top: 24px;
    margin-bottom: 24px;
    width: 100%;

    border-collapse: collapse;
    border: none;

    & tr {
        border-bottom: 1px solid var(--text-color);

        background-color: transparent;
        color: var(--text-color);
    }

    & th {
        font-weight: 600;
        padding: 4px 8px;
        background-color: transparent;
        color: var(--text-color);
        font-size: 0.925rem;

        &:nth-child(1) {
            width: 38%;
        }
        &:nth-child(2) {
            width: 22%;
        }
        &:nth-child(3) {
            width: 22%;
        }
        &:nth-child(4) {
            width: 18%;
        }
    }

    & td {
        padding: 4px 8px;
        &:not(:first-child) {
            text-align: center;
        }
    }
`;